import HelpText from 'components/help-text/help-text';
import Label from 'components/label/label';
import { RegistryCompanyResponse } from 'generated/api-client';
import { CompanyRegistrySearch } from 'modules/company/components/CompanyRegistrySearch';
import React, { FunctionComponent } from 'react';
import { Button, Form, Icon } from 'semantic-ui-react';

type Props = {
  onSelectResult: (result: RegistryCompanyResponse) => void;
  onManualEntrySelected: () => void;
};

export const CompanySearchModalContent: FunctionComponent<Props> = ({
  onSelectResult,
  onManualEntrySelected,
}) => {
  return (
    <>
      <Label>Rechercher dans la base INSEE</Label>
      <Form.Group>
        <CompanyRegistrySearch onSelectResult={onSelectResult} />
        <Button
          primary
          style={{ marginLeft: '15px', minWidth: '270px' }}
          type="submit"
          onClick={onManualEntrySelected}
        >
          <Icon name="edit" />
          Ajouter une entreprise manuellement
        </Button>
      </Form.Group>
      <HelpText style={{ margin: '0px' }}>
        Si vous souhaitez rechercher un entrepreneur individuel, écrivez son
        prénom + nom (Ex: Jean Dupont).
      </HelpText>
    </>
  );
};
